import React, { useEffect, useState } from "react";
import styles from "./PDXO.module.css";
import PDXOModel from "./PDXOModel";
// 🚨 사용하지 않는 plus, minus 아이콘 임포트를 제거하여 파일을 가볍게 만들었습니다.
import downTriangleIcon from "../../img/icon/DownTriangleIcon.png";
import sideTriangleIcon from "../../img/icon/SideTriangleIcon.png";

// props 대신 { search, num, returnFalse } 구조 분해 할당을 사용하여 코드를 깔끔하게!
function PDXO({ search, num, returnFalse }) {
    const [visibleFirst, setVisibleFirst] = useState(true);
    // 초기값을 빈 배열로 세팅하여 불필요한 초기 렌더링 에러를 막습니다.
    const [category, setCategory] = useState([]);

    useEffect(() => {
        const reqOption = {
            method: "GET", // HTTP 메서드는 대문자가 표준
            headers: {
                "content-type": "application/json"
            }
        };

        fetch("/api/GetPDXOCategory", reqOption)
            .then((response) => response.json())
            .then(data => {
                setCategory(data);
            })
            .catch(err => console.error("PDXO Category fetch error:", err)); // 에러 핸들링 추가

        // ★ 검색어와 무관한 API이므로 빈 배열 []을 넣어 최초 1회만 호출되도록 최적화했습니다.
    }, []);

    // 삼항 연산자로 깔끔하게 줄인 함수
    const checkZero = (n) => (!n || n === 0 ? '' : `(${n})`);

    return (
        <>
            {/* 타이틀 전체 영역에 onClick을 하나만 걸고, 마우스 커서를 포인터로 바꿔 클릭할 수 있음을 알려줍니다. */}
            <div className={styles.title} onClick={() => setVisibleFirst(!visibleFirst)} style={{ cursor: 'pointer' }}>
                <span className={styles.outlinePdo}>
                    <img
                        className={visibleFirst ? styles.minusImg : styles.plusImg}
                        src={visibleFirst ? downTriangleIcon : sideTriangleIcon}
                        alt={visibleFirst ? "Collapse" : "Expand"}
                    />
                </span>
                <span className={styles.pdoModels}>
                    PDXO Models
                </span>
                {/* num 객체가 없을 때를 대비해 안전하게 num?.num 처리 */}
                <span className={styles.PDOnumber}>{checkZero(num?.num)}</span>
            </div>

            {/* 조건부 렌더링을 바깥으로 빼내어 불필요한 반복 검사를 없앴습니다. */}
            {visibleFirst && (
                <div className={styles.pdoBox}>
                    {category.map((map, index) => (
                        <PDXOModel
                            name={map.category}
                            search={search}
                            returnFalse={returnFalse} // 래퍼 함수 없이 부모의 함수를 바로 넘깁니다.
                            key={`pdxo-category-${index}`} // 고유한 key 이름 부여
                        />
                    ))}
                </div>
            )}
        </>
    );
}

export default PDXO;